<template>
  <div class="pdf-paginator">
    <template v-if="pageCount">
      Página
      <span>{{value}}</span> / <span>{{ pageCount }}</span>
    </template>
    <input v-else type="number" />
  </div>
</template>

<script>
export default {
  name: 'PDFPaginator',

  props: {
    value: Number,
    pageCount: Number,
  },

  methods: {
    input(event) {
      this.$emit('input', parseInt(event.target.value, 10));
    },
  },

  watch: {
    pageCount() {
      this.$emit('input', 1);
    },
  },
};
</script>

<style>
  input{
    outline: none;
  }
.pdf-paginator {
  color: white;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/pdf/PDFPaginator.vue